export const environment = {
  production: true,
  API_URL: 'https://dev.api.somositv.com/api'
};
